module.exports = __webpack_public_path__ + "static/img/topBanner3.baf49f18.png";